import React, { FC, useEffect, useState } from "react";
import { Tabs, Button, Select, Avatar, Spin, Empty } from "antd";
import moment from "moment";
import { get, uniqBy, clone } from "lodash";
import { VariableSizeList as List } from "react-window";
import InfiniteLoader from "react-window-infinite-loader";

// @ts-ignore
// import Masonry from "react-responsive-masonry";
import TextEditor from "@components/textEditor";
import NotesCard from "@components/drawerNotifications/notes";
import "./drawerNotes.scss";
import { notes } from "./mockData";
import { colors, DataOptions, membersOption, tabs, TNotificationsProps } from "./constant";
import membersService from "@services/members.service";
import { MEMBER_LIST_GLOBAL } from "@utils/constants";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import DataNotFound from "@components/noDataFound";
import { NO_DATA_FOUND } from "../../constants/constants";
// import { useMemberListStore } from "@stores/useMemberListStore";

const text = "The toolbar above the editor can be used for formatting text, as in conventional static editors  …";

const { TabPane } = Tabs;

const Notes: FC<TNotificationsProps> = ({ searchString, filter }) => {
  const [notesData, setNotesData] = useState(notes);
  const [defaultTab, setDefaultTab] = useState("1");
  const [showNoteLayer, newNoteLayerHandle] = useState(false);
  const [selectedMembers, selectedMembersHandler] = useState([]);
  const [notificationsData, setNotificationsData] = useState<any>({});
  const [notificationPreviousDateFilter, setNotificationPreviousDateFilter] = useState(null);

  // const notificationsData = useMemberListStore((state) => state.notificationsData);
  // const setNotificationsData = useMemberListStore((state) => state.setNotificationsData);
  const notesCount = {
    "All Notifications": notificationsData?.totalNotifications,
  };
  const [content, setContent] = useState(text);
  const [height, setheight] = useState<number>();
  const [page, setPage] = useState(1);
  const [notificationsLoader, setNotificationsLoader] = useState<boolean>(false);
  const [ref, setref] = useState<any>();

  useEffect(() => {
    console.log("Notes.useEffect");
    let listHeight = document.querySelector(".right-drawer .ant-drawer-body")?.clientHeight || 500;
    let headerHeight = document.querySelector(".right-drawer .ant-drawer-body .header .ant-tabs .ant-tabs-nav")?.clientHeight || 40;

    setheight(listHeight - headerHeight - 45);
  }, []);

  const bookmarkClickHandler = (data: DataOptions) => {
    const copyNotesData = [...notesData];
    const index = copyNotesData.findIndex((item) => {
      return item.id === data.id;
    });

    copyNotesData[index].isBookMarked = !copyNotesData[index].isBookMarked;
    setNotesData(copyNotesData);
  };

  useEffect(() => {
    if (ref) {
      ref.resetAfterIndex(0, true);
    }
  }, [notificationsData]);

  const onNoteShowMore = (index: number, isShowMore: boolean) => {
    if (notificationsData) {
      let tempNotifications = clone(notificationsData);
      tempNotifications.notifications[index].isShowMore = isShowMore;
      setNotificationsData(tempNotifications);
    }
  };

  const Row: any = (props: any) =>
    notificationsData?.notifications[props.index] ? (
      <div style={props.style}>
        <>
          <NotesCard
            key={`notification_${props.index}`}
            data={notificationsData?.notifications[props.index]}
            width="100%"
            // className="notesCard notesCard_height"
            avatarSize={20}
            bookmarkClickHandler={bookmarkClickHandler}
            onShowMore={(isShowMore: boolean) => {
              onNoteShowMore(props.index, isShowMore);
            }}
          />
        </>
      </div>
    ) : null;

  const getDateFilterValues = () => {
    let fromDate: any = moment.utc(moment(`${moment().format("YYYY-MM-DD")} 23:59:59`).utc());
    let toDate: any = null;

    switch (filter) {
      case "today":
        toDate = moment.utc(moment(`${moment().format("YYYY-MM-DD")} 00:00:00`).utc());
        break;
      case "yesterday":
        toDate = moment.utc(
          moment(`${moment().format("YYYY-MM-DD")} 00:00:00`)
            .subtract(1, "days")
            .utc()
        );
        //'
        fromDate = moment.utc(
          moment(`${moment().format("YYYY-MM-DD")} 23:59:59`)
            .subtract(1, "days")
            .utc()
        );
        break;
      case "last_7_days":
        toDate = moment.utc(
          moment(`${moment().format("YYYY-MM-DD")} 00:00:00`)
            .subtract(7, "days")
            .utc()
        );
        break;
      case "last_2_days":
        toDate = moment.utc(
          moment(`${moment().format("YYYY-MM-DD")} 00:00:00`)
            .subtract(2, "days")
            .utc()
        );
        break;
    }

    return {
      fromDate,
      toDate,
    };
  };

  const fetchNotifications = (nextPage: number, clear?: boolean) => {
    setNotificationsLoader(true);
    const filters = {
      searchString: !searchString || searchString === "" ? null : searchString,
      ...getDateFilterValues(),
    };
    membersService.fetchAllNotifications(nextPage, filters).subscribe({
      next: (v) => {
        const data = v.data.data;
        let notificationsArray = uniqBy([...(clear ? [] : notificationsData?.notifications ? notificationsData?.notifications : []), ...data.notifications], "notificationID")?.sort((a, b) => {
          const dateA = moment(a.notificationDate);
          const dateB = moment(b.notificationDate);
          return dateB.diff(dateA); // Compare in descending order
        });
        setNotificationsData({
          ...notificationsData,
          notifications: notificationsArray,
          totalNotifications: data.readCount + data.unreadCount,
          datetime: get(notificationsArray, "[0].notificationDate"),
        });
        setNotificationsLoader(false);
      },
      error: (e) => {
        console.log(e);
        setNotificationsLoader(false);
      },
    });
  };

  const loadNextNotifications = () => {
    if (notificationsData?.notifications?.length < notificationsData?.totalNotifications) {
      const nextPage: number = page + 1;
      setPage(nextPage);
      fetchNotifications(nextPage);
    }
  };

  useEffect(() => {
    if (notificationPreviousDateFilter !== filter || searchString?.length === 0) {
      setPage(1);
      setNotificationsData({});
      setNotificationPreviousDateFilter(filter);
      fetchNotifications(1, true);
    }
    if (searchString?.length >= 3) {
      setPage(1);
      setNotificationPreviousDateFilter(filter);
      fetchNotifications(1, true);
    }
  }, [searchString, filter]);

  const getNotesCard = () => {
    let data = notificationsData?.notifications;
    if (!Array.isArray(data)) {
      return <Spin spinning style={{ width: "100%" }} indicator={<HealthemSpinner size={45} classname={"mt-1rem"} />} />;
    }

    return (
      <Spin spinning={notificationsLoader} indicator={<HealthemSpinner size={45} />}>
        <div className="allNotes">
          {height && notificationsData?.notifications?.length > 0 && (
            <InfiniteLoader
              isItemLoaded={(index) => index < notificationsData?.notifications?.length}
              itemCount={notificationsData?.notifications?.length < notificationsData?.totalNotifications ? notificationsData?.notifications?.length + 1 : notificationsData?.notifications?.length}
              threshold={1}
              loadMoreItems={() => loadNextNotifications()}
            >
              {({ onItemsRendered, ref }: any) => (
                <List
                  ref={(ref) => setref(ref)}
                  height={height}
                  width={"100%"}
                  itemCount={notificationsData?.notifications?.length < notificationsData?.totalNotifications ? notificationsData?.notifications?.length + 1 : notificationsData?.notifications?.length}
                  itemSize={
                    (index) => {
                      let notification = notificationsData?.notifications[index];
                      let card = document.querySelector(`#drawer_notification_card_${notification?.notificationID}`);
                      // console.log(card)
                      return notification?.isShowMore ? (card?.clientHeight ? card?.clientHeight + 50 : 0) || 350 : (card?.clientHeight ? card?.clientHeight + 25 : 0) || 160;
                    }
                    // (notesHeights && notesHeights[index]) || 140
                  }
                  onItemsRendered={onItemsRendered}
                >
                  {Row}
                </List>
              )}
            </InfiniteLoader>
          )}
          {notificationsData?.notifications?.length === 0 && (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
              <DataNotFound message={NO_DATA_FOUND} />
            </div>
          )}
        </div>
      </Spin>
    );
  };

  const tabsChangeHandler = (activeKey: string) => {
    setDefaultTab(activeKey);
  };

  /*const showNewNote = () => {
    newNoteLayerHandle(true);
  };*/

  const membersChangeHandler = (selectedItems: any) => {
    console.log("selectedItems ##", selectedItems);
    selectedMembersHandler(selectedItems);
  };

  const cancelClickHandler = () => {
    newNoteLayerHandle(false);
  };

  const addNoteHandler = () => {
    membersService.addNotes(selectedMembers, content, MEMBER_LIST_GLOBAL).subscribe({
      next: () => {},
      error: () => {},
    });
    newNoteLayerHandle(false);
  };

  return (
    <div className="notesWrapper">
      <div className="header">
        <Tabs defaultActiveKey={defaultTab} onChange={tabsChangeHandler} size="large">
          {tabs?.map((item: any) => {
            let count: any = notesCount;
            return (
              <TabPane tab={count[item.name] ? `${item.name} (${count[item.name]})` : item.name} key={item.key}>
                {getNotesCard()}
              </TabPane>
            );
          })}
        </Tabs>
      </div>

      {/* <Button
        type="primary"
        shape="circle"
        icon={
          <span style={{ fontSize: "32px", top: "8%" }} className="icon-plus" />
        }
        size="large"
        className="addNewNote"
        onClick={showNewNote}
      /> */}

      {showNoteLayer ? (
        <div className="addNewNoteContainer">
          <div className="backdrop" />
          <div className="editorContainer">
            <h1 className="createNote-title">Create Note</h1>

            <div className="memberlist-row">
              <span className="icon-users" />
              <Select
                mode={"tags"}
                placeholder="Add Members"
                value={selectedMembers}
                onChange={membersChangeHandler}
                style={{ width: "100%" }}
                className="memberlist-select"
                bordered={false}
                showArrow={false}
                maxTagCount={2}
              >
                {membersOption.map((item, index) => (
                  <Select.Option key={item} value={item} className="memberslist-option">
                    {/* <Avatar className="memberlist-avatar" style={{ background: colors[index] }}>
                      {item.charAt(0)}
                    </Avatar> */}
                    <span className="memeberlist-name">{item}</span>
                  </Select.Option>
                ))}
              </Select>
            </div>

            <div className="editor-row">
              <TextEditor content={content} changeHandler={setContent} actionsMenu={true} />
            </div>

            <div className="newNoteFooter">
              <Button type="text" size="large" className="cancel-button" onClick={cancelClickHandler}>
                Cancel
              </Button>
              <Button type="primary" size="large" className="f16 w500 addNoteBtn" onClick={addNoteHandler}>
                Add note
              </Button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Notes;
